import React from 'react'
import { Image } from 'react-bootstrap';
import dolgu from '../../images/home/product_cat/16002484183426.jpg';
import '../../styles/about.css'

const DolguUygulamalari = () => {
  return (
    <div>
      <h5 className='main-title'>Dolgu Uygulamaları</h5>
      <hr />
      <p>Medikal estetik alanında en çok başvurulan temlerden birisi de Hyalüronik asit dolgular uygulamalarıdır. Yüzdeki ince çizgilerin giderilmesi veya yüze hacim kazandırmak için yıllardır kullanılan estetik dolgu uygulaması ile yüzdeki derin kırışıklar, çökük ya da sarkık yanaklar yok olur ve doğal yüz konturları geri döner. Dudak dolgusu, tüm ağız ve kontürler da uyumlu bir sonuç elde edilir, gözaltı dolgusu, cilt gençleştirme, yüz germe, göz çevresi kırışıklığını giderilmesi kullanılır.</p>
      <Image src={dolgu} fluid className='mb-4' style={{ width: '70%' }} />
    </div>
  )
}

export default DolguUygulamalari